import { KpiMetricsData } from 'app/model/tools/kpi-metrics-data';
import { RestfulApiService } from 'app/services/restful-api.service';

class DashboardService extends RestfulApiService<KpiMetricsData> {
    protected getFormName(): string {
        return 'kpi';
    }
    protected getPath(): string {
        return 'kpi';
    }
}

export const dashBoardService = new DashboardService();
